import {
  FormSlug,
  ImplementationGuideForm,
  ResponseFormat,
} from "@/components/ImplementationGuide/types";
import { FieldName } from "@/components/ImplementationGuide/types/FieldName.enum";
import professionalLearningResources from "../resources/professionalLearningResources";

const professionalLearningForm: ImplementationGuideForm = {
  title: "Professional learning",
  subtitle:
    "Plan the professional learning needed to help teachers best use Newsela for their instructional goals.",
  slug: FormSlug.ProfessionalLearning,
  form_image: "/images/implementation-guide/Professional_Learning.svg",
  form_index: 2,
  form_description: {
    content:
      "We will outline the best Professional Learning options to help support your implementation of Newsela.",
    recommendation: "",
  },
  questions: [
    {
      question_index: 1,
      question_text:
        "We have identified the following team member to be the Professional Learning Planner.",
      sub_prompt: null,
      response_format: ResponseFormat.stakeholder_cards,
      is_response_read_only: true,
      field_name: null,
    },
    {
      question_index: 2,
      question_text:
        "We recommend starting your first professional learning within the first 60 days of using Newsela.",
      sub_prompt:
        "Reach out to your Newsela team to learn more about our professional learning options.",
      response_format: ResponseFormat.resource_links,
      is_response_read_only: true,
      response_fields: {
        resource_links: professionalLearningResources,
      },
      field_name: null,
    },
    {
      question_index: 3,
      question_text:
        "How confident are you in your district being able to start professional learning within the first 60 days?",
      sub_prompt: null,
      response_format: ResponseFormat.level_of_confidence,
      is_response_read_only: false,
      field_name: FieldName.Confidence_of_PL_in_First_60_Days,
      response_fields: {
        textarea_title: "Notes",
        textarea_placeholder: "",
        textarea_field_name: FieldName.Professional_Learning_Notes,
      },
    },
  ],
  resources: [
    {
      response_option: "Paid",
      resource_name: "Professional Learning Catalogue",
      resource_link:
        "https://go.newsela.com/rs/628-ZPE-510/images/PL2425Catalog.pdf",
      resource_link_text: "Open PDF",
      todo_item:
        "Reached out to Newsela team member to schedule professional learning",
    },
    {
      response_option: "Paid",
      resource_name: "Suggested Professional Learning Calendar",
      resource_link:
        "https://go.newsela.com/rs/628-ZPE-510/images/Newsela-Professional-Learning-Timeline-One-Pager.pdf?version=0",
      resource_link_text: "Open PDF",
      todo_item: "",
    },
    {
      response_option: "Unpaid",
      resource_name: "Professional Learning Collection",
      resource_link: "https://newsela.com/content/browse/educator-center-root",
      todo_item: "Shared professional learning collection link with teachers.",
    },
  ],
};

export default professionalLearningForm;
